import axios from "axios";
import store from "../store";

class Pipedream {

    async import_data(dataKeyValues) {
        let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					process.env.VUE_APP_SAAS_BACK + "/pipedream/import",
	                dataKeyValues,
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					var data = response.data;
					resolve(data);
				})
				.catch(function (error) {
					reject(error.response);
				});
		}); 
    }
}

export default new Pipedream();